// const { defaults } = require('lodash');

// window.Vue = require('vue');
import Vue from 'vue';

// Create a new Vue instance and export it
const eventBus = new Vue();

export default eventBus;